import { render, staticRenderFns } from "./TournamentEventEntryEdit.vue?vue&type=template&id=3bfe4f28&scoped=true&"
import script from "./TournamentEventEntryEdit.vue?vue&type=script&lang=js&"
export * from "./TournamentEventEntryEdit.vue?vue&type=script&lang=js&"
import style0 from "./TournamentEventEntryEdit.vue?vue&type=style&index=0&id=3bfe4f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfe4f28",
  null
  
)

component.options.__file = "TournamentEventEntryEdit.vue"
export default component.exports